import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type VerifyAddressForDreamSearchViewerComponentQueryVariables = Types.Exact<{
  zip: Types.Scalars['String']['input'];
}>;


export type VerifyAddressForDreamSearchViewerComponentQuery = { __typename?: 'Query', verifyZip: boolean | null };


export const VerifyAddressForDreamSearchViewerComponentDocument = gql`
    query verifyAddressForDreamSearchViewerComponent($zip: String!) {
  verifyZip(zip: $zip)
}
    ` as unknown as DocumentNode<VerifyAddressForDreamSearchViewerComponentQuery, VerifyAddressForDreamSearchViewerComponentQueryVariables>;